<div class="footer-at-bottom-wrapper">
	<app-header></app-header>

	<div class="layout">
		<div class="side-nav" *ngIf="!isMobileDeviceSize">
			<app-side-navigation class="full-height"></app-side-navigation>
		</div>
	  <div [ngClass]="useContentFormPadded() ? 'content' : 'form-content'">
	    <router-outlet></router-outlet>
	  </div>
	</div>

	<app-footer class="footer-at-bottom"></app-footer>
</div>